import RoutesContainer from './RoutesContainer';
export default RoutesContainer;



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/RelayRootContainer/components/IntlContainer/components/RoutesContainer/index.js